<template>
  <div>
    <Head title="Paneli" />


    <div class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/3 mt-4 mb-4">
      <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
    </div>

    <Teleport class="lg:w-1/4" to="body">
      <!-- use the modal component, pass in the prop -->
      <modal  :show="showScanSuccessModal" @close="showScanSuccessModal = false; scanLocked = false;">
        <template #header>
          <div></div>
        </template>

        <template #body>
          <div class="flex justify-center">
            <h1 class="text-green-500 text-2xl">Kodi u skanua me sukses!</h1>
          </div>
        </template>

        <template #footer>
          <div class="flex flex-wrap justify-center">
            <loading-button @click = "showScanSuccessModal = false; scanLocked = false;" class="btn-indigo" type="button">OK</loading-button>
          </div>
        </template>
      </modal>
    </Teleport>

<!--    <div class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/3 mt-4 mb-4">-->
<!--      <button @click="onDecode">HIT</button>-->
<!--    </div>-->

    <div class="flex flex-wrap lg:flex-nowrap w-full lg:w-1/3 mt-4 mb-4">
      <input ref="scanInput" v-model="scan_url" @keydown.enter="scan()" class="relative border px-6 py-3 w-full rounded focus:shadow-outline mt-3 lg:mt-0" autocomplete="off" type="text" placeholder="Skano..." />
    </div>

    <div class="flex flex-wrap mb-4">
      <label class="font-bold">Total: &nbsp{{this.scanned_orders.length}}</label>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2">ID</th>
          <th class="pb-4 pt-6 px-2">ID tjetër</th>
          <th  class="pb-4 pt-6 px-2">Statusi</th>
          <th  class="pb-4 pt-6 px-2"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="order in scanned_orders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100 bg-red" :class="{'bg-red-300' : order.status_description === 'Deshtoi'}">

          <td class="border-t px-2 py-4">
            <Link class="flex items-center " target="_blank" :href="getOrderUrl(order.id)" tabindex="-1">
              {{ order.id }}
            </Link>

          </td>
          <td class="border-t px-2 py-4">
              {{ order.custom_id }}
          </td>
          <td class="border-t px-2 py-4">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="order.color">
                {{ order.status_description }}
              </span>
          </td>

          <td class="border-t px-2 py-4">
            {{ order.error_message }}
          </td>

        </tr>
        <tr v-if="scanned_orders.length === 0">
          <td class="px-2 py-4 border-t" colspan="14">Asnje skanim deri me tani...</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import axios from 'axios'
import TextInput from '@/Shared/TextInput.vue'
import Icon from '@/Shared/Icon.vue'
import Dropdown from '@/Shared/Dropdown.vue'
import {computed} from 'vue'
import StreamBarcodeReader from '@/Shared/StreamBarcodeReader.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import Modal from '@/Shared/Modal.vue'



export default {
  components: {
    Modal, LoadingButton,
    StreamBarcodeReader,
    Dropdown, Icon,
    TextInput,
    TextareaInput,
    Head,
    Link
  },
  layout: Layout,
  props: {
    app_url: String
  },
  data(){
    return {
      scans: null,
      scan_url: null,
      scanned_orders: [],
      showScanSuccessModal: false,
      scanLocked: false
    }
  },
  mounted() {
    document.addEventListener("click", this.unlockAudio, { once: true });

    this.$refs.scanInput.focus()
  },
  methods: {
    scan(){

      let scanUrl = this.scan_url;

      let orderId = '';

      this.scan_url = null;

      try {
        // Try to parse as URL
        const url = new URL(scanUrl);
        // If it's a valid URL, get the last part after the last slash
        orderId = scanUrl.substring(scanUrl.lastIndexOf('/') + 1);
      } catch (e) {
        // Not a valid URL, use full string
        orderId = scanUrl;
      }

      this.scanned_orders.unshift({
        id: orderId,
        status_id: -1,
        color: 'bg-gray-400',
        status_description: 'Duke u procesuar...',
        error_message: ''
      })

      let self = this;
      axios.get(`/ajax/scan/order/${orderId}`).then(function (response){
        if(response.status === 200){
          let order = self.scanned_orders.find(order => (order.id === response.data.order_id || order.id === response.data.custom_id) && order.status_id === -1);
          order.id = response.data.order_id
          order.color = self.getStatusColor(response.data.status_id)
          order.status_description = response.data.status_description
          order.custom_id = response.data.custom_id
        }
      }).catch((error) => {
        self.scanned_orders.filter(order => order.id === orderId).forEach((order)=>{
          order.color = 'bg-red-500'
          order.status_description = 'Deshtoi'
          order.error_message = error.response ? error.response.data.message : error.message
        });


        // Play beep sound 3 times
        let i = 0;
        let interval = setInterval(()=>{
          self.playBeepSound();
          i++;

          if(i === 3){
            clearInterval(interval);
          }
        },200)
      })
    },

    getStatusColor(statusId){
      let statusColor = 'bg-indigo-500'

      if(statusId === 1)
        statusColor = 'bg-yellow-500'

      if(statusId === 3)
        statusColor = 'bg-orange-500'

      if(statusId === 4)
        statusColor = 'bg-indigo-900'

      if(statusId === 5)
        statusColor = 'bg-green-500'

      if(statusId === 6)
        statusColor = 'bg-yellow-700'

      if(statusId === 7)
        statusColor = 'bg-red-500'

      if(statusId === 8)
        statusColor = 'bg-gray-400'

      if(statusId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    },

    playBeepSound(){
      const beep = new Audio('/storage/sounds/scan-beep.mp3');
      beep.play();
    },

    getOrderUrl(orderId){
      let url = '';
      switch (this.user.role){
      case 'superadmin': url = route('admin.orders.show',{order: orderId}); break;
      case 'admin': url = route('admin.orders.show',{order: orderId}); break;
      case 'delivery_driver': url = route('delivery-driver.orders.show',{order: orderId}); break;
      case 'collecting_driver': url = route('collecting-driver.orders.show',{order: orderId}); break;
      case 'warehouseman': url = route('warehouseman.orders.show',{order: orderId}); break;
      }

      return url;
    },


    onDecode(result){
      if(this.scanLocked){
        return;
      }

      this.scanLocked = true;

      this.scan_url = result;

      const enterEvent = new KeyboardEvent('keydown', {
        key: 'Enter',
        keyCode: 13,
        which: 13,
        bubbles: true,
      });
      this.$refs.scanInput.dispatchEvent(enterEvent);

      this.playBeepSound();

      this.showScanSuccessModal = true;

      this.scan_url = null;
    },

    onLoaded(){

    },

    async unlockAudio() {
      if (this.audioUnlocked) return; // Prevent multiple unlock attempts

      try {
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const response = await fetch("/storage/sounds/scan-beep.mp3");
        const arrayBuffer = await response.arrayBuffer();
        this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer);

        this.audioUnlocked = true;
        console.log("Audio unlocked and loaded!");
      } catch (error) {
        console.error("Failed to unlock audio:", error);
      }
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
